import './Target.css';
import logoLong from '../assets/logo-long-black.png';
import { useScrollReveal } from '../hooks/useScrollReveal';

function Target() {
    const [ref, visible] = useScrollReveal(0.15);
    return (
        <section ref={ref} className={`target ${visible ? 'visible' : ''}`}>
            <div className="target-content">
                <h2 className="section-title"> If you're running...</h2>
                <div className="target-grid">
                    <div className="target-item">
                        <div className="check-icon">
                            <i className="fas fa-check-circle"></i>
                        </div>
                        <h4>A small to medium clinic without dedicated IT staff</h4>
                    </div>
                    <div className="target-item">
                        <div className="check-icon">
                            <i className="fas fa-check-circle"></i>
                        </div>
                        <h4>An independent practice that values autonomy</h4>
                    </div>
                    <div className="target-item">
                        <div className="check-icon">
                            <i className="fas fa-check-circle"></i>
                        </div>
                        <h4>A clinic still using paper files or spreadsheets</h4>
                    </div>
                </div>
                <h2 className="target-conclusion">
                    Then <img src={logoLong} alt="Lemadoo" className="inline-logo" /> is built for you. No complexity, no IT department needed—just clarity.
                </h2>
            </div>
        </section>
    );
}

export default Target;
